'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _queryAdvanced = require('./query-advanced.js');

var _queryAdvanced2 = _interopRequireDefault(_queryAdvanced);

var _superagent = require('../network-interfaces/superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var queryMiddleware = (0, _queryAdvanced2.default)(_superagent2.default);

exports.default = queryMiddleware;


/*****************
 ** WEBPACK FOOTER
 ** ../~/redux-query/dist/commonjs/middleware/query.js
 ** module id = 317
 ** module chunks = 3
 **/